/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-22 14:31:25
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-07 16:19:12
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelMultiLanguageSelect/slice/index.ts
 */
import { createSlice, createSelector } from '@reduxjs/toolkit';
import { EnumReducers } from 'src/store/constants';
//import { get } from 'lodash';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import { assData } from 'src/tools/helper';

const target = (state) => {
  return state[EnumReducers.responsivePreviewSize];
};

const defaultData = {
  selectedSize: EPreviewSize.WIDE,
  errorSet: {
    [EPreviewSize.WIDE]: false,
    [EPreviewSize.NARROW]: false,
    [EPreviewSize.TABLET]: false,
    [EPreviewSize.MOBILE]: false,
  },
};

const salesChannelPreviewSize = createSlice({
  name: 'salesChannelPreviewSize',
  initialState: defaultData,
  reducers: {
    updatePreviewSize(state, action) {
      //console.log('action.payload', action.payload);
      state.selectedSize = action.payload;
    },
    updatePreviewSizeError(state, action) {
      assData(state.errorSet, action.payload);
    },
  },
});

const currentSelectedSize = () => {
  return createSelector(
    (state: any) => {
      return target(state).selectedSize;
    },
    (selectedSize) => {
      return selectedSize;
    },
  );
};

const currentSelectedSizeErrors = () => {
  return createSelector(
    (state: any) => {
      return target(state).errorSet;
    },
    (errorSet) => {
      return errorSet;
    },
  );
};

export { currentSelectedSize, currentSelectedSizeErrors };
export const { updatePreviewSize } = salesChannelPreviewSize.actions;

export default salesChannelPreviewSize.reducer;
